import { storeToRefs } from 'pinia';

// Public API over the CometChat session store (Phase 5 Messages). Components read
// reactive `status` / `error` / `currentUserUid` and call `setup`/`retry`/`logout`
// without touching the store or the SDK directly.
export default function useCometChat() {
    const store = useCometchatStore();
    const { status, error, currentUserUid, isReady } = storeToRefs(store);

    return {
        status,
        error,
        currentUserUid,
        isReady,
        setup: store.setup,
        retry: store.retry,
        logout: store.logout,
    };
}
